import { render, staticRenderFns } from "./UploadFilesModal.vue?vue&type=template&id=65453fb8&"
import script from "./UploadFilesModal.vue?vue&type=script&lang=js&"
export * from "./UploadFilesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports